import { createSlice } from "@reduxjs/toolkit";

const initialState = {dynamiclink:null,url_params:null};

const dynamiclinkigReducer = createSlice({
  name: "dynamiclinkigReducer",
  initialState,
  reducers: {
    setApiResult(state,action){
      state.dynamiclink = action.payload;
    },
    setUrlParams(state,action){
      const params = new URLSearchParams(action.payload.search);
      const queryParams = Object.fromEntries(params);
      state.url_params = queryParams;
    },
    resetDynamicLink(state){
      state.dynamiclink = null;
      state.url_params = null;
    }

  },
});
export const { setApiResult,setUrlParams,resetDynamicLink } = dynamiclinkigReducer.actions;
export default dynamiclinkigReducer.reducer;
